import { Stack } from '@mui/material';
import React, { useState } from 'react';
import AutocompleteMuiCustom from '../../../components/common/AutocompleteMuiCustom';
import { useQuery } from '../../../hooks/UseQuery';
import InputMuiCustom from '../../../components/common/inputs/InputMuiCustom';
import { SubmitButton } from '../../../components/common/button/CustomButtons';
import { ModuleDataHandler } from '../helpers/handleReportCalc';

const AutoAddDaysValue = ({
  moduleData,
  numberOfDay,
  setIsAddModal,
  setModuleData,
}: any) => {
  const [partCode, setPartCode] = useState<any>(
    moduleData?.map((item: any) => {
      const part_id =
        typeof item?.part_id !== 'string' ? item?.part_id._id : item?.part_id;
      const part_number =
        typeof item?.part_id !== 'string'
          ? item?.part_id.part_number
          : item?.part_number;
      return {
        ...item,
        part_id,
        part_number,
      };
    })
  );
  const annual_date: any = useQuery('annual_date')?.split('-')[0];
  const [day, setDay] = useState(
    Array.from({ length: numberOfDay }, (_, i) => ({
      day: `${annual_date}-${i + 1}`,
    }))
  );
  const [autoPartCode, setAutoPartCode] = useState<any>();
  const [autoDay, setAutoDay] = useState<any>();
  const [value, setValue] = useState<any>(null);
  const dataHandler = new ModuleDataHandler(moduleData);

  const handleSumbit = () => {
    if (!autoPartCode) {
      alert('Pick Part Code');
      return;
    }
    if (!autoDay) {
      alert('Pick a Day First');
      return;
    }

    const qty_days_idx = autoDay.day && autoDay.day.split('-')[1] - 1;
    const getPartIdx = moduleData.findIndex((item: any) => {
      const partID =
        typeof item?.part_id !== 'string' ? item?.part_id._id : item?.part_id;
      return partID == autoPartCode?.part_id;
    });

    if (getPartIdx >= 0) {
      moduleData[getPartIdx].qty_days_arr[qty_days_idx] = value || null;
      dataHandler.handleTotalDispatchAndSaleAmount(getPartIdx);
      setModuleData(moduleData);
    }
    alert('succesfully updated');
    setIsAddModal(false);
  };
  return (
    <>
      <Stack direction={'row'} gap={2} width={'50vw'}>
        <AutocompleteMuiCustom
          id="part_number"
          label="PICK PART CODE"
          sx={{ width: '16.6vw' }}
          option_name="part_number"
          arrayofObj={partCode}
          value={autoPartCode}
          onChange={(e, value) => {
            setAutoPartCode(value);
            setAutoDay('');
            setValue(null);
          }}
        />

        <AutocompleteMuiCustom
          id="part_number"
          label="PICK DAY"
          key={autoDay}
          sx={{ width: '16.6vw' }}
          option_name="day"
          arrayofObj={day}
          value={autoDay}
          onChange={(e, value) => {
            const qty_days_idx = value?.day && value.day.split('-')[1] - 1;
            setValue(autoPartCode?.qty_days_arr?.[qty_days_idx]);
            setAutoDay(value);
          }}
        />

        <InputMuiCustom
          type="number"
          name="key_contact"
          variant="outlined"
          placeholder="VALUE"
          onChange={(e) => {
            setValue(+e.target.value);
          }}
          value={value}
        />
      </Stack>
      <div
        className="btn_save"
        style={{
          position: 'absolute',
          right: '140px',
          top: '-0.6px',
        }}
      >
        <SubmitButton label={`submit`} type="button" onClick={handleSumbit} />
      </div>
    </>
  );
};

export default AutoAddDaysValue;
